import React from 'react';
import {View} from 'react-native';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';

import {styles} from './Loading.style';
interface LoadingProps {
  renderTitle: () => string;
}

export const Loading: React.FC<LoadingProps> = ({}) => {
  const {tt} = useTranslation('reportCardContent.client');
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text emphasis="low" style={styles.heading} variant="subheading">
            {tt('title', 'Total expiring wellness Credits in the next 14 days')}
          </Text>
          <LoadingBox style={styles.loadingBoxWellnessCredits} />
        </Gutter>
        <View>
          <Gutter style={styles.listItemHeader}>
            <ListItem
              label={<Text>{tt('expiration', 'Expiration')}</Text>}
              suffix={<Text>{tt('amount', 'Amount')}</Text>}
            />
          </Gutter>
          <Gutter>
            <ListItem
              style={{base: styles.listItem}}
              label={<LoadingBox style={styles.loadingBoxExpirationDate} />}
              suffix={<LoadingBox style={styles.loadingBoxExpirationAmount} />}
            />
          </Gutter>
        </View>
      </View>
    </View>
  );
};
